import handleClick from '../../../../../utils/handleClick';
import computeClassName from "../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: 'appearance-none inline-flex flex-row items-center justify-center cursor-pointer font-bold'
});

export const propsDefaults = Object.freeze( {
  label: '',
  fn: null,
  fnArgs: undefined,
  className: ''
});

function getComputedClassName(propsClassName) {
  return computeClassName(propsClassName, constants.CLASSNAME_BASE);
}

export default function CCAnnouncementActionControl(
  {
    label = propsDefaults.label,
    fn = propsDefaults.fn,
    fnArgs = propsDefaults.fnArgs,
    className = propsDefaults.className
  }) {
  const computedClassName = getComputedClassName(className);
  return (
    <button className={computedClassName}
            onClick={handleClick(fn, fnArgs)}>{label}</button>
  );
}
